// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__1Z_hp","alert":"SettungsInbox_alert__2QW5l"};